/**
 * Format API distance for UI — matches iOS Home feed.
 * Backend floors calculated values ≤1.4 to 1; 0 means "not calculated".
 */
export function formatDistanceKm(distance: number | undefined | null): string | null {
  if (distance == null || !Number.isFinite(distance) || distance <= 0) {
    return null;
  }
  return `${Math.max(1, Math.round(distance))} km`;
}

export function formatDistanceKmAway(distance: number | undefined | null): string | null {
  const label = formatDistanceKm(distance);
  return label ? `${label} away` : null;
}
